import React from 'react';
import PropTypes from 'prop-types';
import CardActions from "@material-ui/core/CardActions";
import Button from "@material-ui/core/Button";

const SketchOrderCardActions = props => (
    <CardActions>
        <Button
            color="secondary"
            onClick={() => props.onUpdateClick()}
            disabled={props.isFetching}
        >
            Update
        </Button>
    </CardActions>
);

SketchOrderCardActions.propTypes = {
    sketchOrder: PropTypes.shape({
        sketchOrderStatus: PropTypes.string,
    }).isRequired,
    onUpdateClick: PropTypes.func.isRequired,
    isFetching: PropTypes.bool,
};

SketchOrderCardActions.defaultProps = {
    isFetching: false,
};

export default SketchOrderCardActions;
